import BaseComponent from "../../../../../lib/components/BaseComponent";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import {Tab, Tabs, TextField} from "@mui/material";
import TabPanel from "../../../../../lib/components/tabbar/TabPanel";

class TabBarTest extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      outerTabValue: 0,
      innerTabValue: 0
    }
  }

  handleChange(event, newValue) {
    this.setState({outerTabValue: newValue});
  };

  handleChangeInnerTab(event, newValue) {
    this.setState({innerTabValue: newValue});
  };

  render() {
    return <VerticalLayout className='sandbox-container gap-4'>
      <Tabs value={this.state.outerTabValue} onChange={(event, newValue) => this.handleChange(event, newValue)} aria-label="basic tabs example" variant="scrollable" scrollButtons="auto">
        <Tab label="Item One" index={0}/>
        <Tab label="Item Two" index={1}/>
        <Tab label="Item Three" index={2}/>
        <Tab label="Item One2" index={3}/>
        <Tab label="Item Two2" index={4}/>
        <Tab label="Item Three2" index={5}/>
      </Tabs>
      <TabPanel value={this.state.outerTabValue} index={0}>
        <TextField/>
      </TabPanel>
      <TabPanel value={this.state.outerTabValue} index={1}>
        Item Two
        <Tabs value={this.state.innerTabValue} onChange={(event, newValue) => this.handleChangeInnerTab(event, newValue)} aria-label="basic tabs example2" variant="scrollable" scrollButtons="auto">
          <Tab label="Item One" index={0}/>
          <Tab label="Item Two" index={1}/>
        </Tabs>
        <TabPanel value={this.state.innerTabValue} index={0}>
          <TextField/>
        </TabPanel>
        <TabPanel value={this.state.innerTabValue} index={1}>
          Item Two
        </TabPanel>
      </TabPanel>
      <TabPanel value={this.state.outerTabValue} index={2}>
        Item Three
      </TabPanel>
      <TabPanel value={this.state.outerTabValue} index={3}>
        <TextField/>
      </TabPanel>
      <TabPanel value={this.state.outerTabValue} index={4}>
        Item Two
      </TabPanel>
      <TabPanel value={this.state.outerTabValue} index={5}>
        Item Three2
      </TabPanel>
    </VerticalLayout>
  }
}

export default TabBarTest;
